import { useDispatch } from 'react-redux'
import axios from 'axios'
import { reset } from 'redux-form'
import { showErrorToast, showSuccessToast } from '../../../state/toasts'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../../components'
import {Slider} from '../../../components'
import { UPLOAD_FORM_NAME, UploadForm } from './UploadForm'
import {TicketService,UploadsService} from "../../../services";
import {TicketPrint, UploadContent} from "../../../api";
import AttachmentList from './AttachmentList'
import {useEffect, useState} from "react";
export type AttachmentsProps={
  ticket:TicketPrint & {uploaded_contents:Array<UploadContent>}
  onTicketUpdate:(ticket:TicketPrint)=>void
}
const Attachments = ({ ticket, onTicketUpdate }:AttachmentsProps) => {
  const [uploadMessage,setUploadMessage] = useState<string>()
  const dispatch = useDispatch()
  let timer = null
  const getExt = (fileName?:string) => {
    if(!fileName){
      return
    }
    const ext = fileName.split('.').pop()
    if (ext == fileName) return ''
    return ext
  }

   useEffect(() => {
    return () => clearTimeout(timer);
  }, []);

  const handleFormSubmit = (values:any) => {
    const fd = {}
    fd.extension= getExt(values?.files?.name) || ''
    fd.file_name= values?.files?.name
    fd.description= values.description
    fd.upload_type= values.upload_type
    fd.file_size= values.files.size
    fd.gsx_module_type= values.gsx_module_type
    let url = ''
      let gsx_module_type=null
    new TicketService().upload2(`${ticket.url}upload2/`, fd)
      .then((response) => {
        setUploadMessage("Uploading file to EaseOn")
        url = response.url
        gsx_module_type = response.gsx_module_type
        axios.put(response.s3_upload_put_path, values.files, {
          headers: {
            'Content-Type': values.files.type,
          },
        }).then((response2)=>{
            if(gsx_module_type && gsx_module_type!=="Don't Upload to GSX"){
                        setUploadMessage("Waiting for file to be ready to upload to gsx")
                  setUploadMessage("Uploading file to gsx")
                  new UploadsService(url).upload_to_gsx().then(()=>{
                       dispatch(showSuccessToast('Success', 'Attachment uploaded successfully'))
                                 dispatch(reset(UPLOAD_FORM_NAME))
                    })
            }
          setUploadMessage(null)
          dispatch(reset(UPLOAD_FORM_NAME))
          onTicketUpdate({...ticket,uploaded_contents:[response,...ticket.uploaded_contents]})
          dispatch(showSuccessToast('Success', 'Attachment uploaded successfully'))
        })






      })
      .catch((errors) =>
        dispatch(showErrorToast('Error', 'Attachment uploaded failed.'))
      )
  }
  return (
    <div className="mt-5">
      <ReactBootstrap.Card className="mt-5">
        <ReactBootstrap.Card.Title className="card-header bg-dark text-white card-header">
          <ReactBootstrap.Row>
            <ReactBootstrap.Col xs="6">Attachments</ReactBootstrap.Col>
            <ReactBootstrap.Col xs="6" className="text-end">
              <Slider sliderWidth={"50vw"} header="Add Documents" title={components.ICONS.PLUS}>
                <UploadForm uploadMessage={uploadMessage} onSubmit={handleFormSubmit} />
              </Slider>
            </ReactBootstrap.Col>
          </ReactBootstrap.Row>
        </ReactBootstrap.Card.Title>
        <ReactBootstrap.Card.Body>
          <AttachmentList
            ticket={ticket}
            onTicketUpdate={() => onTicketUpdate(ticket)}
          />
        </ReactBootstrap.Card.Body>
      </ReactBootstrap.Card>
    </div>
  )
}

export default Attachments
